import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import React from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import logo from "/assets/LoginLogo.png";
import { LoginContextData } from "../Declarations";
import { useLogin } from "../hooks/useLogin";
import { useState } from "react";

interface ICredentialsFormProps {
    onSuccess: (ctx: LoginContextData) => void;
    BrowserFingerprint: string;
}

export const CredentialsForm = ({ onSuccess, BrowserFingerprint}: ICredentialsFormProps) => {
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string | null>(null);

    const loginMutation = useLogin();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        loginMutation.mutate(
            {
                BrowserFingerprint: BrowserFingerprint,
                Password: password,
                UserAgent: navigator.userAgent,
                UserName: username,
            },
            {
                onError: (err: unknown) => {
                    let message = "Login failed";
                    if (typeof err === "object" && err !== null && "message" in err) {
                        message = String((err as any).message);
                    }
                    setError(message);
                },
                onSuccess: (response) => {
                    onSuccess({
                        BrowserFingerprint: BrowserFingerprint,
                         LoginMessage: response.LoginMessage,
                        NewPassword: undefined,
                        Password: password,
                        TwoFACode: undefined,
                        UserID: response.UserID,
                        UserName: username,
                        ValidUserNamePassword: response.ValidUserNamePassword,
                    });
                },
            }
        );
    };

    return (
        <>
        <Grid container spacing={2}>

            <Grid size={{ xs: 12 }}>
                <Typography sx={{ fontWeight: "bold" }} variant="h5">CS Login</Typography>
            </Grid>
            <Grid size={{ xs: 3 }} sx={{ display: "flex", justifyContent: "left" }}>
                <img height="60" src={logo} title="North Sails Logo" width="60" />
            </Grid>
            <Grid size={{ xs: 9 }}>
                <form onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                        <TextField

                            id="InputUserName"
                            label="User Name"
                            variant="outlined"
                            slotProps={{
                                input: { autoComplete: "username" },
                            }}
                            sx={{
                                width: "350px",
                                input: {
                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                WebkitTextFillColor: "#000",
                                caretColor: "#000",
                                },
                                "& input:-webkit-autofill": {
                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                WebkitTextFillColor: "#000",
                                caretColor: "#000",
                                transition: "background-color 5000s ease-in-out 0s",
                                },
                            }}
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                handleSubmit(event);
                                }
                            }}
                        />
                        <TextField

                            id="InputPassword"
                            label="Password"
                            type="password"
                            variant="outlined"
                            slotProps={{
                                input: { autoComplete: "current-password" },
                            }}
                            sx={{
                                width: "350px",
                                input: {
                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                WebkitTextFillColor: "#000",
                                caretColor: "#000",
                                },
                                "& input:-webkit-autofill": {
                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                WebkitTextFillColor: "#000",
                                caretColor: "#000",
                                transition: "background-color 5000s ease-in-out 0s",
                                },
                            }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                handleSubmit(event);
                                }
                            }}
                        />

                        {error !== null && <p className="error">{error}</p>}

                        <Button
                            color="primary"
                            disabled={loginMutation.isPending}
                            fullWidth={false}
                            sx={{ width: "175px" }}
                            type="submit"
                            variant="contained"
                        >
                            {loginMutation.isPending ? "Logging in..." : "Login"}
                        </Button>
                    </Stack>
                </form>
            </Grid>

        </Grid>
        </>
    );
};
